/**
 * Locale-aware date formatter for the staff (and wider) portal.
 *
 * Uses Intl.DateTimeFormat and delegates the locale string to
 * utils/locale.appLocale(), which combines the UI language with the
 * company's `number_digits` setting (see settings → Digits). The Gregorian
 * calendar is kept everywhere this formatter is used today — no screen
 * switches to Hijri under either digit choice.
 *
 * @param {string|number|Date} value   Date input (ISO string, timestamp, or Date).
 * @param {string} [lang]              Language code ('ar' → ar-SA, otherwise en-US).
 * @param {Intl.DateTimeFormatOptions} [options]  Optional Intl formatting options.
 * @returns {string} Formatted date, or '' for null/invalid input.
 */
import { appLocale } from './locale';

export function fmtDate(value, lang, options) {
  if (value === null || value === undefined || value === '') return '';

  const date = value instanceof Date ? value : new Date(value);
  if (isNaN(date.getTime())) return '';

  const locale = appLocale(lang);

  try {
    return new Intl.DateTimeFormat(locale, options).format(date);
  } catch (err) {
    // Unknown locale/options should never crash the UI — fall back to en-US.
    return new Intl.DateTimeFormat('en-US', options).format(date);
  }
}

export default fmtDate;